import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError } from 'rxjs/operators';
import { FormComponent } from 'src/app/components/form/form.component';
import { FormDataDto, GroupLists, SelfRegImageDto, SelfRegImageIdsDto, ServiceSelectionDto } from 'src/app/services/dtos';
import { HttpSubmissionService } from 'src/app/services/http-submission.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
	selector: 'app-dynamic-form',
	templateUrl: './dynamic-form.component.html',
	styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent {

	formData: FormDataDto[];
	imageIds: SelfRegImageIdsDto;
	serviceSelectionDto: ServiceSelectionDto;
	groupLists?: Map<number, Array< GroupLists > >;
	@Output() onNext = new EventEmitter();
	@Output() onBack = new EventEmitter();
	@Output() onImageCaptured = new EventEmitter<any>();

	@ViewChildren("axonform") form: QueryList<FormComponent>;

	savedImages: SelfRegImageDto[] = [];

	constructor(
		private httpSubmissionService: HttpSubmissionService, 
		private spinner: NgxSpinnerService, 
		private toast: ToastService,
		private utilService: UtilService,
		private translateService: TranslateService) { 

    }

	@Input() 
	set serviceSelection(serviceSelection: ServiceSelectionDto) {
		this.serviceSelectionDto = serviceSelection;

		if (this.formData && this.serviceSelectionDto && this.imageIds) {
			this.populateFieldsWithImages();
		}
	}

	@Input() 
	set formDataDto(formData: FormDataDto[]) {
		this.formData = formData;

		if (this.formData && this.serviceSelectionDto && this.imageIds) {
			this.populateFieldsWithImages();
		}
	}
	@Input() 
	set savedImageIds(savedImageIds: SelfRegImageIdsDto) {
		this.imageIds = savedImageIds;

		if (this.formData && this.serviceSelectionDto && this.imageIds) {
			this.populateFieldsWithImages();
		}
	}

	populateFieldsWithImages() {

		if (this.imageIds) {
			this.imageIds.imageIds.forEach(item => {
				this.spinner.show();
				this.httpSubmissionService.getSavedImage(this.serviceSelectionDto, item)
				.pipe(
					catchError(error => {
						this.spinner.hide();
						console.log('Error', error);
						
						this.toast.show('Unable to fetch previously Saved images: ' + error.error.message);
						throw error;
					})
				)
				.subscribe(
					data => {
						// console.log(data);
						this.savedImages.push(data);
						this.spinner.hide();

						this.formData.forEach(formDataDto => {
							formDataDto.data.cards.forEach(card => {
								card.fields.forEach(field => {
									this.savedImages.forEach(image => {
										if (image.fieldId === field.id) {
											let prefix = "data:image/" + image.imageExt + ";base64,";
											let file = new File([this.utilService.dataURItoBlob(prefix + image.image)], 'image.' + image.imageExt, {type:"image/" + image.imageExt});
											field.formControl.setValue(file);
											field.imageId = image.imageId;
										}
									})
								});
							});
						});
					}
				);
			});	
		}
	}
	
	previousStep() {
		this.onBack.emit();
	}

	nextStep() {

		this.form.forEach(item => {
			item.prepFormValidity();
		})

		if ( !this.isFormValid ) {
			this.toast.show('Please check your form. Some values are invalid / missing');
			this.form.forEach(item => {
				const firstInvalidKey = Object.keys(item.form.controls)
    				.find(key => item.form.get(key)?.invalid);
				console.log('firstInvalidKey:', firstInvalidKey);
				if (firstInvalidKey) {
  					const invalidElement = document.getElementById(firstInvalidKey);
					if (invalidElement) {
						invalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
						(invalidElement as HTMLElement).focus();
					}
				}
			});
			return;
		}
		this.onNext.emit( {'formData': this.formData });
	}

	get isFormValid() {
		console.log('form: ', this.form);
		if ( !this.form ) {
			console.log('Form is not found');
			return false;
		}
		var valid = true;
		this.form.forEach( item => {
			if (!item.isFormValid()) {
				console.log('Form is invalid');
				valid = false;
			}
		});

		console.log('Form is valid: ', valid);
		return valid;
	}

	uploadImage($event) {
		if (this.onImageCaptured) {
			this.onImageCaptured.emit($event);
		}
	}
}
